import type { OverlayRequest } from '@hibro/shared';

/** 诊断面板里的那条：弹层已经打开，但窗口没能到前台。 */
export const OPEN_MODAL_FOCUS_REJECTED =
  'openModal could not bring its window to the foreground';

/** 弹层已经关掉，但借来的焦点还不回唤起它的那扇窗口。 */
export const OPEN_MODAL_RETURN_REJECTED =
  'openModal could not return to the window that opened it';

/**
 * `openModal` 是否该把宿主窗叫到前台。
 *
 * 只有 modal 看 `focus`，省略等于要聚焦。窗口已经在前台就不再动它。
 * drawer、popover 和声明档（confirm / alert / prompt / select）一律不激活窗口。
 */
export function shouldPresentHostWindow(
  request: OverlayRequest,
  hostFocused: boolean,
): boolean {
  return (
    request.role === 'view' &&
    request.presenter === 'modal' &&
    request.focus !== false &&
    !hostFocused
  );
}

/**
 * 让当前页试着拿到前台。`window.focus()` 被浏览器拒绝时不会抛错，
 * 只能靠调用之后 {@link Document.hasFocus} 仍为 false 看出来。
 */
export function focusHostPage(): boolean {
  window.focus();
  return document.hasFocus();
}
